import { useEffect, useState } from 'react'
import { useGameStore } from '@/store/gameStore'

const BINANCE_WS = 'wss://stream.binance.com:9443/ws'
const SYMBOLS: Record<string, string> = {
  BTC: 'btcusdt',
  ETH: 'ethusdt',
  SOL: 'solusdt',
}

export function useLivePrice() {
  const { currentCrypto } = useGameStore()
  const [price, setPrice] = useState<number | null>(null)

  useEffect(() => {
    setPrice(null)  // Reset on crypto change — prevents stale price from previous crypto
    const symbol = SYMBOLS[currentCrypto]
    if (!symbol) return

    const ws = new WebSocket(`${BINANCE_WS}/${symbol}@trade`)
    ws.onmessage = (e) => {
      const data = JSON.parse(e.data)
      setPrice(parseFloat(data.p))
    }
    ws.onerror = () => setPrice(null)

    return () => ws.close()
  }, [currentCrypto])

  return price
}
